import { memo, useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import BotIsTyping from './BotIsTyping';
import Footer from './Footer';
import Header from './Header';
import Message from './Message';

import './Content.scss';

const Content = ({ content, isFetching, message, messages, requestVersion = 0, setContent, setIsFetching, setMessage, setMessages, syncNotice = "", taskParams }) => {
  const chatRef = useRef(),
        chatBottomRef = useRef()

  useLayoutEffect(() => {
    if(!chatRef.current || !chatBottomRef.current) {
      return;
    }
    const scrollToBottom = () => chatBottomRef.current?.scrollIntoView({ behavior: "smooth", block: "end" }),
          frameId = requestAnimationFrame(scrollToBottom)
    return () => cancelAnimationFrame(frameId)
  }, [isFetching, messages.length])

  return (
    <div className="ng-python-editor__chat__content">
      <Header/>
      <div
          className="ng-python-editor__chat__content__chat"
          ref={chatRef}
      >
        {messages.length === 0 ? (
          <div className="ng-python-editor__chat__content__empty">
            {syncNotice || "Ask for a code change or generate a new code."}
          </div>
        ) : messages.map((item, index) => (
          <Message
              generatedCode={item.generatedCode}
              key={`PythonEditorChatMessage${index}`}
              message={item.message}
              setContent={setContent}
              sourceCode={item.sourceCode}
              type={item.type}
          />
        ))}
        <BotIsTyping isTyping={isFetching}/>
        <div
            aria-hidden="true"
            ref={chatBottomRef}
        />
      </div>
      <Footer
          content={content}
          isFetching={isFetching}
          message={message}
          requestVersion={requestVersion}
          setIsFetching={setIsFetching}
          setMessage={setMessage}
          setMessages={setMessages}
          taskParams={taskParams}
      />
    </div>
  )
}

Content.propTypes = {
  content: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  messages: PropTypes.array.isRequired,
  requestVersion: PropTypes.number,
  setContent: PropTypes.func.isRequired,
  setIsFetching: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
  setMessages: PropTypes.func.isRequired,
  syncNotice: PropTypes.string,
  taskParams: PropTypes.object
}

export default memo(Content);
